export type LogoutReason =
	| 'session_invalidated'
	| 'session_expired'
	| 'token_reuse_detected'
	| 'account_not_verified'
	| 'terms_not_accepted'
	| 'generic'

export function getLogoutReasonFromError(errorData: unknown): LogoutReason {
	if (!errorData || typeof errorData !== 'object') {
		return 'session_expired'
	}
	const detail = (errorData as Record<string, unknown>).detail
	if (typeof detail === 'object' && detail !== null) {
		const reason = (detail as Record<string, unknown>).reason
		if (reason === 'session_invalidated') return 'session_invalidated'
		if (reason === 'token_reuse_detected') return 'token_reuse_detected'
		if (reason === 'account_not_verified') return 'account_not_verified'
		if (reason === 'terms_not_accepted') return 'terms_not_accepted'
	}
	return 'session_expired'
}

export function isUserActionLogoutReason(
	reason: LogoutReason | undefined
): reason is
	| 'session_invalidated'
	| 'token_reuse_detected'
	| 'account_not_verified'
	| 'terms_not_accepted' {
	return (
		reason === 'session_invalidated' ||
		reason === 'token_reuse_detected' ||
		reason === 'account_not_verified' ||
		reason === 'terms_not_accepted'
	)
}
